export default __webpack_public_path__ + "static/media/Banner2_revamp_En.98c3aaed.webp";